import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Button,
  Link,
  Grid,
} from "@material-ui/core";
import MyLink from "./MyLink";

const About: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOpen = () => {
    setIsOpen(true);
  };
  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <>
      <Grid container justify="flex-end">
        <Grid item>
          <Link onClick={handleOpen} data-cy="about-link">
            About
          </Link>
        </Grid>
      </Grid>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="About Wacky News Reader"
        aria-describedby="About Wacky News Reader"
        data-cy="about-modal"
      >
        <DialogTitle>About Wacky News Reader</DialogTitle>
        <DialogContent>
          <DialogContentText>Let me explain myself here. 😛</DialogContentText>
          <DialogContentText>
            I would like to show you all how the fonts and the styling can make
            information harder or easier to comprehend. In addition, different
            fonts and styling imply different mood. Well, I am not joking about
            reading serious news in Comics Sans MS!
          </DialogContentText>
          <DialogContentText>
            The 90s mode has been inspired by{" "}
            <MyLink href="https://www.theyeticafe.com/">The Yeti Cafe</MyLink>
            's menu online. The word art has been generated by{" "}
            <MyLink href="https://www.makewordart.com/">Make Word Art</MyLink>.
            The various animated gifs have been gotten from{" "}
            <MyLink href="https://gifcities.org/">Gif Cities</MyLink>. (If you
            can show me a better source, please let me know.) The hit counter is
            from{" "}
            <MyLink href="https://github.com/joshwcomeau/react-retro-hit-counter">
              React Retro Hit Counter
            </MyLink>
            . The news feed consists of the real news headlines from{" "}
            <MyLink href="https://developer.nytimes.com/">
              The New York Times Developer Network
            </MyLink>
            .
          </DialogContentText>
          <DialogContentText>
            Questions? Comments? Please feel free to{" "}
            <MyLink href="https://clarmso.typeform.com/to/BW4tWf">
              contact me
            </MyLink>
            .
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} data-cy="close-modal-button">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default About;
